/**
 * @generated SignedSource<<ff8a243cea50b637aa5624ee34f611a5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ExpenseCategory = "CONSULTING_AND_ADMINISTRATION" | "HARDWARE_AND_EQUIPMENT" | "INFRASTRUCTURE" | "INSURANCE" | "MEMBERSHIPS_AND_DONATIONS" | "OTHER" | "SERVICES_AND_LICENSES" | "TRAVEL" | "VEHICLES" | "%future added value";
export type ResetExpenseInvoiceCategoryInput = {
  id: string;
};
export type IncomingInvoiceViewResetCategoryMutation$variables = {
  input: ResetExpenseInvoiceCategoryInput;
};
export type IncomingInvoiceViewResetCategoryMutation$data = {
  readonly resetExpenseInvoiceCategory: {
    readonly expenseCategory: ExpenseCategory | null | undefined;
    readonly expenseCategoryOverride: ExpenseCategory | null | undefined;
    readonly id: string;
  };
};
export type IncomingInvoiceViewResetCategoryMutation = {
  response: IncomingInvoiceViewResetCategoryMutation$data;
  variables: IncomingInvoiceViewResetCategoryMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ExpenseInvoice",
    "kind": "LinkedField",
    "name": "resetExpenseInvoiceCategory",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "expenseCategory",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "expenseCategoryOverride",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "IncomingInvoiceViewResetCategoryMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "IncomingInvoiceViewResetCategoryMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "c9d34d7627e02981b723db80514b6b2c",
    "id": null,
    "metadata": {},
    "name": "IncomingInvoiceViewResetCategoryMutation",
    "operationKind": "mutation",
    "text": "mutation IncomingInvoiceViewResetCategoryMutation(\n  $input: ResetExpenseInvoiceCategoryInput!\n) {\n  resetExpenseInvoiceCategory(input: $input) {\n    id\n    expenseCategory\n    expenseCategoryOverride\n  }\n}\n"
  }
};
})();

(node as any).hash = "0490f162ec9e2c125656097692c58ce0";

export default node;
